// Confirmar o celular pelo WhatsApp: código de 6 números. Aparece no cadastro (contas sem celular confirmado)
// e quando a pessoa troca de número em Ajustes > Segurança.
import { useState } from 'react';
import { KeyboardAvoidingView, Platform, ScrollView, Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { confirmarCodigo, enviarCodigo } from '../lib/celular';
import { useTecladoAndroid, ROLAGEM_TECLADO } from './teclado';
import { Btn, Field } from './ui';
import { C } from './theme';
import { t } from '../lib/i18n';

const COR = '#25D366';

export function ConfirmarCelular({ titulo, onPronto, onCancelar }: { titulo?: string; onPronto: (tel: string) => void; onCancelar?: () => void }) {
  const ins = useSafeAreaInsets();
  const teclado = useTecladoAndroid();
  const [tel, setTel] = useState('+55 ');
  const [enviado, setEnviado] = useState(false);
  const [codigo, setCodigo] = useState('');
  const [msg, setMsg] = useState<{ txt: string; erro?: boolean } | null>(null);
  const [indo, setIndo] = useState(false);
  const enviar = async () => {
    setIndo(true); setMsg(null);
    try { await enviarCodigo(tel); setEnviado(true); setMsg({ txt: t('Mandamos um código de 6 números no WhatsApp do número {tel}.', { tel: tel.trim() }) }); }
    catch (e: any) { setMsg({ txt: String(e?.message ?? e), erro: true }); }
    finally { setIndo(false); }
  };
  const confirmar = async () => {
    setIndo(true); setMsg(null);
    try { onPronto(await confirmarCodigo(codigo)); }
    catch (e: any) { setMsg({ txt: String(e?.message ?? e), erro: true }); }
    finally { setIndo(false); }
  };
  return (
    <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} style={{ flex: 1, backgroundColor: C.bg }}>
      <ScrollView {...ROLAGEM_TECLADO} keyboardShouldPersistTaps="handled" contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', padding: 24, gap: 14, paddingTop: ins.top + 20, paddingBottom: ins.bottom + 30 + teclado }}>
        <Text style={{ fontSize: 52, textAlign: 'center' }}>📱</Text>
        <Text style={{ color: C.text, fontSize: 22, fontWeight: '800', textAlign: 'center' }}>{titulo ?? t('Confirme o seu celular')}</Text>
        <Text style={{ color: C.sub, textAlign: 'center' }}>{t('Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.')}</Text>
        {!enviado ? (<>
          <Field value={tel} onChangeText={setTel} keyboardType="phone-pad" placeholder="+55 41 99999-0000" autoFocus />
          <Text style={{ color: C.mute, fontSize: 12 }}>{t('Com o código do país e o DDD. Ex.: +55 41 99999-0000')}</Text>
          <Btn cor={COR} label={indo ? t('Aguarde...') : '💬 ' + t('Receber o código no WhatsApp')} disabled={indo || tel.replace(/\D/g, '').length < 10} onPress={enviar} />
        </>) : (<>
          <Field value={codigo} onChangeText={x => setCodigo(x.replace(/\D/g, '').slice(0, 6))} keyboardType="number-pad" placeholder="000000" autoFocus
            style={{ fontSize: 28, letterSpacing: 8, textAlign: 'center' }} maxLength={6} />
          <Btn cor={COR} label={indo ? t('Aguarde...') : t('Confirmar')} disabled={indo || codigo.length !== 6} onPress={confirmar} />
          <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 20 }}>
            <Text style={{ color: COR, fontWeight: '700' }} onPress={() => { setEnviado(false); setCodigo(''); setMsg(null); }}>{t('Trocar o número')}</Text>
            <Text style={{ color: COR, fontWeight: '700' }} onPress={enviar}>{t('Mandar de novo')}</Text>
          </View>
        </>)}
        {!!msg && <Text style={{ color: msg.erro ? C.danger : C.ok, textAlign: 'center' }}>{msg.txt}</Text>}
        {onCancelar && <Text style={{ color: C.sub, textAlign: 'center', padding: 10 }} onPress={onCancelar}>{t('Cancelar')}</Text>}
      </ScrollView>
    </KeyboardAvoidingView>
  );
}
